import axios from "axios";

export default (token = null) => {
  if (token) {
    axios.defaults.headers.common.authorization = `Bearer ${token}`;
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers.common["Access-Control-Allow-Headers"] =
      "Origin, X-Requested-With, Content-Type, Accept, Authorization";
    axios.defaults.headers.common["Content-Type"] =
      "application/x-www-form-urlencoded; charset=UTF-8";
    axios.defaults.headers.common["Access-Control-Allow-Methods"] =
      "GET,POST,PUT,DELETE,OPTIONS";
    axios.defaults.headers.common["Access-Control-Allow-Credentials"] = "true";
  } else {
    delete axios.defaults.headers.common.authorization;
  }
};



// WEBPACK FOOTER //
// ./src/utils/setAuthorizationHeader.js